import { render, staticRenderFns } from "./EndControl.vue?vue&type=template&id=4c68acbc&"
import script from "./EndControl.vue?vue&type=script&lang=ts&"
export * from "./EndControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports